<template>
<div class="vc-page">
  <header-bar>
    <icon-button slot="left" @click="back()" icon="arrow_back"></icon-button>
    <span>Circular</span>
  </header-bar>
  <scroll-view>
    <div class="vc-content-block">
      <circular style="margin-left: 16px;"></circular>
      <circular style="margin-left: 16px;" color="green" :size="36"></circular>
      <circular style="margin-left: 16px;" color="amber" :size="48"></circular>
    </div>
  </scroll-view>
</div>
</template>

<script>
export default {
  methods: {
    back () {
      window.history.back()
    }
  }
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** circular.vue?458ed5ba
 **/